"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTransactionV2 = exports.calculateTransaction = exports.calculateTransactionItem = exports.calculateTransactionTotal = exports.refundableTransactions = exports.REFUNDABLE_TRANSACTION_STATUSES = exports.balanceTransactions = exports.BALANCE_TRANSACTION_STATUSES = exports.DiscountType = exports.TransactionStatus = void 0;
const mathjs_1 = require("mathjs");
var TransactionStatus;
(function (TransactionStatus) {
    TransactionStatus["PAID"] = "paid";
    TransactionStatus["PENDING"] = "pending";
    TransactionStatus["CANCELLED"] = "cancelled";
    TransactionStatus["DECLINED"] = "declined";
    TransactionStatus["REFUND"] = "refund";
    TransactionStatus["REFUND_PENDING"] = "refund-pending";
    TransactionStatus["REFUND_FAILED"] = "refund-failed";
    TransactionStatus["INVOICE"] = "invoice";
})(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["PERCENTAGE"] = "percentage";
})(DiscountType || (exports.DiscountType = DiscountType = {}));
exports.BALANCE_TRANSACTION_STATUSES = [
    TransactionStatus.PAID,
    TransactionStatus.REFUND,
    TransactionStatus.REFUND_PENDING,
    TransactionStatus.INVOICE,
];
const balanceTransactions = (transactions) => {
    return transactions.filter((txn) => exports.BALANCE_TRANSACTION_STATUSES.includes(txn.status));
};
exports.balanceTransactions = balanceTransactions;
exports.REFUNDABLE_TRANSACTION_STATUSES = [
    TransactionStatus.PAID,
    TransactionStatus.INVOICE,
];
const refundableTransactions = (transactions) => {
    return transactions.filter((txn) => exports.REFUNDABLE_TRANSACTION_STATUSES.includes(txn.status));
};
exports.refundableTransactions = refundableTransactions;
const calculateTransactionTotal = (txn) => {
    if (txn.total || txn.total === 0)
        return txn.total;
    return (0, mathjs_1.round)(txn.items
        .map((i) => {
        const base = i.product.price * i.quantity;
        return base;
    })
        .reduce((total, current) => total + current, 0), 2);
};
exports.calculateTransactionTotal = calculateTransactionTotal;
const calculateTransactionItem = (item, discount) => {
    // We have to calculate values like this because of Stripe - Stripe
    // takes prices in cents, and doesn't accept fractional cents
    // Calculating the discount on the full price means you wind up with
    // rounding errors on the Stripe integration, because breaking it down
    // again yields fractional-cent values (which get rounded off, and cause
    // a discrepancy of several cents vs. the actual value)
    const calculateDiscountedPrice = () => {
        if (!discount) {
            const existing = item.discount || 0;
            return item.product.price + existing / item.quantity;
        }
        if (discount.discount_type === DiscountType.PERCENTAGE) {
            return (0, mathjs_1.round)(item.product.price -
                item.product.price * (discount.value / 100), 2);
        }
        return 0;
    };
    const basePrice = (0, mathjs_1.round)(item.product.price, 2);
    const discounted = calculateDiscountedPrice();
    item.subtotal = (0, mathjs_1.round)(basePrice * item.quantity, 2);
    item.discount = (0, mathjs_1.round)((discounted - basePrice) * item.quantity, 2);
    item.total = (0, mathjs_1.round)(item.subtotal + item.discount, 2);
    return item;
};
exports.calculateTransactionItem = calculateTransactionItem;
const calculateTransaction = (txn, discount) => {
    txn.items = txn.items.map((item) => (0, exports.calculateTransactionItem)(item, discount));
    const calculatedTotal = txn.items.reduce((prev, item) => ({
        subtotal: prev.subtotal + item.subtotal,
        discount: prev.discount + item.discount,
        total: prev.total + item.total,
    }), { subtotal: 0, discount: 0, total: 0 });
    // Round it off here too to deal with the inevitable floating-point errors
    txn.subtotal = (0, mathjs_1.round)(calculatedTotal.subtotal, 2);
    txn.discount = (0, mathjs_1.round)(calculatedTotal.discount, 2);
    txn.total = (0, mathjs_1.round)(calculatedTotal.total, 2);
    if (txn.total === 0 && txn.status === TransactionStatus.PENDING) {
        txn.status = TransactionStatus.PAID;
    }
    return txn;
};
exports.calculateTransaction = calculateTransaction;
const calculateTransactionV2 = (txnItems) => {
    const calculatedTotal = txnItems.reduce((prev, item) => ({
        subtotal: prev.subtotal + item.subtotal,
        discount: prev.discount + item.discount,
        total: prev.total + item.total,
    }), { subtotal: 0, discount: 0, total: 0 });
    const txn = {
        id: '',
        subtotal: 0,
        discount: 0,
        total: 0,
        status: TransactionStatus.PENDING,
        items: txnItems,
        created_at: new Date(),
    };
    // Round it off here too to deal with the inevitable floating-point errors
    txn.subtotal = (0, mathjs_1.round)(calculatedTotal.subtotal, 2);
    txn.discount = (0, mathjs_1.round)(calculatedTotal.discount, 2);
    txn.total = (0, mathjs_1.round)(calculatedTotal.total, 2);
    if (txn.total < 0) {
        txn.status = TransactionStatus.REFUND_PENDING;
    }
    return txn;
};
exports.calculateTransactionV2 = calculateTransactionV2;
